import type { ServiceType, ProductCategoryDef, ProductTemplate } from '../api/types';

/**
 * Resolve ServiceType from a product template's category using:
 * 1. Explicit serviceType on the matching ProductCategory (from DB)
 * 2. Heuristic fallback based on the category slug
 * 3. Default ALTRO
 */
export function resolveServiceType(
  template: { category: string },
  categories: ProductCategoryDef[],
): ServiceType {
  const cat = categories.find(c => c.slug === template.category);
  if (cat?.serviceType) return cat.serviceType as ServiceType;

  const n = template.category.toLowerCase();

  // Slug-based heuristic — handles both legacy hyphen and new underscore variants
  if (n.includes('album')) return 'ALBUM';
  if (n.includes('stamp') || n.includes('print')) return 'STAMPA_RISTORANTE';
  if (n.includes('poster')) return 'POSTER';
  if (n.includes('usb')) return 'USB_PERSONALIZZATA';
  if (n.includes('drone')) return 'DRONE';
  if (n.includes('shoot')) return 'SHOOTING_PRE';
  if (n.includes('trailer')) return 'TRAILER';
  if (n.includes('reel')) return 'REEL';
  if (n.includes('sde')) return 'SDE';
  // Check 'servizio-foto' / 'servizio_foto' / 'foto' — do this before generic 'video' check
  if (n === 'servizio-foto' || n === 'servizio_foto' || n.includes('foto')) return 'REPORTAGE_FOTO';
  if (n === 'servizio-video' || n === 'servizio_video' || n.includes('videomaker')) return 'VIDEOMAKER';
  if (n.includes('video')) return 'VIDEO_MATRIMONIO';
  if (n.includes('fine_art') || n.includes('fine-art')) return 'STAMPA_FINE_ART';
  if (n.includes('secondo_fotografo') || n.includes('secondo-fotografo')) return 'SECONDO_FOTOGRAFO';
  if (n.includes('mini_album') || n.includes('mini-album')) return 'MINI_ALBUM_GENITORI';

  return 'ALTRO';
}

/**
 * Resolve the category icon from ProductCategory.icon field.
 * Falls back to a default Package icon.
 */
export function resolveCategoryIcon(
  template: { category: string },
  categories: ProductCategoryDef[],
): string {
  const cat = categories.find(c => c.slug === template.category);
  return cat?.icon ?? 'Package';
}
